import * as React from "react";
import Box from "@mui/material/Box";
import { ITextFieldStyles } from "@fluentui/react/lib/TextField";
import { LTLState } from "@taskpane/hooks/useLTLReducer";
import type { TmsProviderCapabilities } from "@src/types/api";
import { ShipmentDetailsZipsAndDate } from "./ShipmentDetailsZipsAndDate";
import { ShipmentDetailsModeEquipment } from "./ShipmentDetailsModeEquipment";

interface ShipmentDetailsFormProps {
  state: LTLState;
  providerConfig: TmsProviderCapabilities;
  onFieldChange: (field: keyof LTLState["form"], value: string) => void;
  onFieldBlur?: () => void;
  onShipmentModeChange: (mode: "LTL" | "Truckload") => void;
  onEquipmentChange: (equipment: string) => void;
  getTextFieldStyles: (fieldName: keyof LTLState["form"]) => Partial<ITextFieldStyles>;
}

const styles = {
  container: {},
  grid: {},
};

export function ShipmentDetailsForm({
  state,
  providerConfig,
  onFieldChange,
  onFieldBlur,
  onShipmentModeChange,
  onEquipmentChange,
  getTextFieldStyles,
}: ShipmentDetailsFormProps) {
  return (
    <Box className="shipment-details-container" sx={styles.container}>
      <Box className="shipment-details-grid" sx={styles.grid}>
        <ShipmentDetailsZipsAndDate
          state={state}
          onFieldChange={onFieldChange}
          onFieldBlur={onFieldBlur}
          getTextFieldStyles={getTextFieldStyles}
        />
        <ShipmentDetailsModeEquipment
          state={state}
          providerConfig={providerConfig}
          onShipmentModeChange={onShipmentModeChange}
          onEquipmentChange={onEquipmentChange}
        />
      </Box>
    </Box>
  );
}
